import { GridCol, GridContainer, Icon, ICONS } from '@bob/library'
import Heading from '@websrc/App/Components/Heading/Heading'
import { getAnchorPropsFromLink } from '@websrc/App/Helpers/getAnchorPropsFromLink'
import { spotWrapperProps } from '@websrc/App/Helpers/spotWrapperProps'
import { useLocale } from '@websrc/App/Hooks/useLocale'
import { mapSegmentSelectorSpot } from '@websrc/DataMappers/mapSpot'
import { SpotLinkButton } from '@websrc/Spot/Link/SpotLinkButton'
import React from 'react'

import { LearnMoreButtonType } from '../Collapse/SpotCollapse'
import * as SC from './SpotSegmentSelector.style'

export interface SpotSegmentSelectorProps {
  spot: ReturnType<typeof mapSegmentSelectorSpot>['segment_selector']
  LearnMoreButton?: LearnMoreButtonType
  imageLazy?: boolean
  withinExpandable?: boolean
  isTopOfPage?: boolean
}

export const SpotSegmentSelector = ({
  LearnMoreButton,
  spot,
  imageLazy,
  withinExpandable,
  isTopOfPage,
}: SpotSegmentSelectorProps) => {
  const locale = useLocale()

  const renderContent = (
    <div>
      <SC.Header>
        <Heading
          description={spot.description}
          headline={spot.headline}
          label={spot.caption}
          level={isTopOfPage ? 1 : 2}
          size={'xxl'}
        />
      </SC.Header>
      {LearnMoreButton && (
        <SC.LearnMoreButtonWrapper>
          <LearnMoreButton />
        </SC.LearnMoreButtonWrapper>
      )}
      <SC.ItemListWrapper>
        {spot.items.slice(0, 4).map(({ item }, i) => {
          const anchorProps = getAnchorPropsFromLink(item.link, locale)

          return (
            <SC.ItemWrapper {...anchorProps} key={i}>
              <Heading
                headline={item.title}
                level={isTopOfPage ? 2 : 3}
                size={'s'}
                style={{ textAlign: 'center' }}
              />
              {item.asset && (
                <SC.ProductImage
                  lazyLoading={imageLazy}
                  sizes={'(min-width: 1024px) 350px'}
                  srcSetWidths={[320, 400, 600, 800, 1200]}
                  {...item.asset}
                />
              )}
              <SpotLinkButton ctaType={'tertiary'} link={item.link}>
                <Icon icon={ICONS.ARROW_RIGHT} size={16} />
                <span>{item.link.cta_text}</span>
              </SpotLinkButton>
            </SC.ItemWrapper>
          )
        })}
      </SC.ItemListWrapper>
    </div>
  )

  if (withinExpandable) {
    return renderContent
  }

  return (
    <GridContainer>
      <GridCol {...spotWrapperProps(spot.caption)}>{renderContent}</GridCol>
    </GridContainer>
  )
}
